import { toast } from "react-toastify";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const handleTicketAccessToUser = async (
  contactId, userId, userProfile, status, isBotInteractionFinished, whatsappId, isCreatedByUser = null, successFunction
) => {
  try {
    let params = {
      contactId,
      userId,
      status,
      isBotInteractionFinished,
      whatsappId
    };

    if (isCreatedByUser) params = { ...params, isCreatedByUser };

    const apiCalls = [
      api.get("/settings/adminCanViewOtherChats"),
      api.get(`/userQueuesIds/${userId}`),
      api.post("tickets", params)
    ];

    const [AdminCanViewOtherChatsResponse, UserQueuesIdsResponse, TicketResponse] = await Promise.all(apiCalls);
    const adminCanViewOtherChats = AdminCanViewOtherChatsResponse.data.value;
    const userQueuesIds = UserQueuesIdsResponse.data;
    const ticket = TicketResponse.data;

    const pendingTicketCondition = ticket.status === "pending" && (ticket.queueId === null || userQueuesIds.includes(ticket.queueId));
    const openTicketAndAdminUserCondition = ticket.status === "open" && userProfile === "admin" && adminCanViewOtherChats === "enabled";
    const openTicketAndCommonUserCondition = ticket.status === "open" && ticket.userId === userId;
    const canUserAccessTicket = pendingTicketCondition || openTicketAndAdminUserCondition || openTicketAndCommonUserCondition;

    // ***---- User can access Ticket ----***
    if (canUserAccessTicket) {
      successFunction(ticket.id, ticket.status);
      return;
    }

    // ***---- User cannot access Ticket: Pending Ticket in Another Queue ----***
    if (ticket.status === "pending") {
      toast.info(`
        ${i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET")}
        ${i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET_QUEUE")}
        ${ticket.queue?.name}  
      `);

      return;
    }

    // ***---- User cannot access Ticket: Ticket with Another User ----***
    toast.info(`
      ${i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET")}
      ${i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET_USER")}
      ${ticket.user?.name}  
    `);
  } catch (exception) {
    console.log("Handle Ticket Access to User Exception:", exception);
    toastError(exception);
  }
};

export default handleTicketAccessToUser;
